<template>
  <div style="width: 100%; height: calc(100vh - 150px);">
    <div v-if="$store.state.isGoogleApiLoaded" class="position-relative" style="width: 100%; height: 100%;">
      <div class="driverSearch">
        <p>Caută după indicativ: </p>
        <b-form-input autocomplete="off"  class="driverSearchIndicativ" placeholder="___" v-model="markerSearch"></b-form-input>
        <b-button class="ml-2" size="sm" variant="primary" @click="togglePoly">Afișează zonele</b-button>
        <b-button class="ml-2" size="sm" variant="secondary" @click="toggleFullscreen">
          <b-icon :icon="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"></b-icon>
        </b-button>
      </div>
      <l-map
        ref="map"
        v-if="driversLocations"
        :center="this.$store.getters['auth/loggedUser'].id !== 1 ? mapCenter : createLatLng(45.9442858, 25.0094303)"
        :zoom="this.$store.getters['auth/loggedUser'].id !== 1 ? 13 : 7"
      >
        <l-tile-layer
          :url="tilesUrl"
        />
        <l-marker
          v-for="(m, index) in driversLocationsFiltered"
          :key="index"
          :lat-lng="{ lat: m.lat, lng: m.long }"
          @click="driverInfo(m.userId)"
        >
          <l-icon
            class-name="someExtraClass"
          >
            <div :style="{backgroundColor: m.is_busy ? 'red' : 'green', color: '#fff', width: '25px', height: '25px', textAlign: 'center', lineHeight: '25px', borderRadius: '50%', fontSize: '10px'}">
              {{ m.indicativ }}
            </div>
          </l-icon>
        </l-marker>
        <template v-if="showPoly === true">
          <l-polygon
            v-for="poly in polygonsRawList"
            :key="'poly-' + poly.id"
            :lat-lngs="extractPolygonPaths(poly)"
            :color="'#000'"
            :weight="1"
            class="mapPoly"
          >
            <l-popup :content="poly.name" />
          </l-polygon>
        </template>
      </l-map>
      <div class="driverInfo" v-show="showDriverInfo" :class="{ showDriver: showDriverInfo }">
        <b-card>
          <b-card-body body-class="p-0">
            <b-card-title>{{ Sofer.identifier ? Sofer.identifier : '' }} <b-button variant="danger" size="sm" class="pull-right" @click="hideDriverInfo"><b-icon icon="x"></b-icon></b-button></b-card-title>
            <b-card-sub-title class="mb-2">{{ Sofer.name }}  </b-card-sub-title>
            <b-card-text>
              <table class="w-100">
                <tr>
                  <td>Balanța: </td>
                  <td>{{ Sofer.balance }} RON</td>
                </tr>
                <tr>
                  <td>Ocupat: </td>
                  <td v-if="Sofer.is_busy" class="text-danger">Da</td>
                  <td v-else class="text-success">Nu</td>
                </tr>
                <tr>
                  <td>Prioritate:</td>
                  <td v-if="Sofer.high_priority != 0" class="text-success">Da <b-icon icon="star-fill"></b-icon></td>
                  <td v-else class="text-success">Nu</td>
                </tr>
                <!-- <tr>
                  <td>Aplicație:</td>
                  <td>
                    <UserMeta :type="'simple'" :user-id="Sofer.id" />
                  </td>
                </tr> -->
              </table>
              <div class="mt-2" v-if="Sofer.is_busy">

                <strong>Comenzi active:</strong>
                <b-list-group>
                  <b-list-group-item  class="d-flex px-2 py-1" :to="{ name: 'OperatorOrderView', params: { id: order.id } }" v-for="order in driverHistory" :key="order.id">
                    <span class="mr-2"> #{{ order.id }}: </span>
                    <div v-if="order.places[0].name">
                      <span v-if="order.places[0].name.length >= 35">
                        {{ order.places[0].name.substring(0,35)+".." }}
                      </span>
                      <span v-else>{{ order.places[0].name }}</span>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-card-text>

          </b-card-body>

            <template #footer>
              <b-row>
                <b-button class="ml-3 mr-1" size="sm" variant="secondary" target="_blank" :href="'/user/' + Sofer.id + '/driver'"> Edit <b-icon icon="pencil-square"></b-icon></b-button>
                <UserBanControl v-if="Sofer" :user="Sofer"></UserBanControl>
                <b-button disabled v-b-modal.driverOrders :user-id="Sofer.id" class="mx-1" size="sm" variant="primary"> Istoric comenzi <b-icon icon="list"></b-icon></b-button>
                <b-button @click="openMessages" class="ml-1 mr-3" size="sm" variant="success"> Mesaj <b-icon icon="envelope"></b-icon></b-button>
              </b-row>

            </template>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import mapIcoFree from '@/assets/driverLocFree.svg'
import mapIcoBusy from '@/assets/driverLocBusy.svg'
import mapIcoPaused from '@/assets/driverLocBan.svg'
import config from '@/config'
import Vue from 'vue'
import ClickOutside from 'vue-click-outside'
import UserBanControl from '@/components/users/UserBanControl'
// import GerOrders from '@/components/orders/GetOrders'
// import GmapCluster from 'vue2-best-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

import { LMap, LTileLayer, LMarker, LIcon, LPolygon, LPopup } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'

export default {
  name: 'DriversMap',
  components: { UserBanControl, LMap, LTileLayer, LMarker, LIcon, LPolygon, LPopup },
  data () {
    return {
      polygons: [],
      polygonsRawList: [],
      driversLocations: [],
      driversData: [],
      driverHistory: [],
      driverD: '',
      selected: null,
      optionsSaved: [
        { value: null, text: 'Barbu Lautaru 12' },
        { value: 'a', text: 'Aleea Florilor 7B' }
      ],
      MapStyle: {
        mapTypeControl: false,
        streetViewControl: false
      },
      showDriverInfo: false,
      showPoly: false,
      // InfoWindow
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoContent: '',
      infoWinOpen: false,
      fillC: [
        '#000',
        '#fff'
      ],
      selectedColor: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      Sofer: '',
      getDriverPositionsInterval: null,
      markerSearch: '',
      tilesUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      isFullscreen: false
    }
  },
  mounted () {
    this.popupItem = this.$el
    this.getDriverPositions()
    this.getSavedPolygons()

    this.getDriverPositionsInterval = setInterval(this.getDriverPositions, 25000)

    // Слушаем изменения fullscreen режима (например, при нажатии ESC)
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
  },
  beforeDestroy () {
    clearInterval(this.getDriverPositionsInterval)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
  },
  computed: {
    mapCenter () {
      return latLng(this.$store.getters['auth/companyLocation'].lat, this.$store.getters['auth/companyLocation'].lng)
    },
    driversLocationsFiltered () {
      if (this.markerSearch) {
        return this.driversLocations.filter((item) => {
          return item.indicativ === this.markerSearch
        })
      }
      return this.driversLocations
    }
  },
  methods: {
    extractPolygonPaths (polygon) {
      return polygon.paths.map(item => [item.lat, item.long])
    },
    createLatLng (lat, lng) {
      return latLng(lat, lng)
    },
    showPolygonDesc (event, name) {
      console.log(event)
      const contentString = name
      this.infoWindowPos = event.latLng
      this.infoContent = contentString
      this.infoWinOpen = true
    },
    togglePoly () {
      this.showPoly = !this.showPoly
    },
    toggleFullscreen () {
      const mapContainer = this.$refs.map.$el
      if (!document.fullscreenElement) {
        mapContainer.requestFullscreen().then(() => {
          this.isFullscreen = true
          this.$nextTick(() => {
            if (this.$refs.map && this.$refs.map.mapObject) {
              this.$refs.map.mapObject.invalidateSize()
            }
          })
        }).catch(err => {
          console.error('Error attempting to enable fullscreen:', err)
        })
      } else {
        document.exitFullscreen().then(() => {
          this.isFullscreen = false
          this.$nextTick(() => {
            if (this.$refs.map && this.$refs.map.mapObject) {
              this.$refs.map.mapObject.invalidateSize()
            }
          })
        })
      }
    },
    handleFullscreenChange () {
      this.isFullscreen = !!document.fullscreenElement
      this.$nextTick(() => {
        if (this.$refs.map && this.$refs.map.mapObject) {
          this.$refs.map.mapObject.invalidateSize()
        }
      })
    },
    getSavedPolygons () {
      return Vue.axios.get(config.baseApiUrl + '/api/polygons')
        .then((response) => {
          this.polygonsRawList = response.data.data.map((polygon) => {
            polygon.isVisible = true
            return polygon
          })
        })
    },
    getDriverOrders (driverId) {
      this.$axios.get(config.baseApiUrl + '/api/orders?driver_id=' + driverId + '&state=assigned')
        .then(response => {
          this.driverHistory = response.data.data
        })
    },
    toggleDriverInfo () {
      this.showDriverInfo = true
    },
    hideDriverInfo () {
      this.showDriverInfo = false
    },
    getDriverPositions () {
      this.$axios.get(config.baseApiUrl + '/api/drivers-positions')
        .then(response => {
          this.driversLocations = response.data
        })
    },
    getDriverData (driverId) {
      this.$axios.get(config.baseApiUrl + '/api/users/' + driverId)
        .then(response => {
          this.Sofer = response.data
        })
    },
    driverInfo (driverId) {
      this.showDriverInfo = true
      this.getDriverData(driverId)
      this.getDriverOrders(driverId)
    },
    markerIcon (data) {
      if (data.is_busy) {
        return {
          url: mapIcoBusy,
          strokeColor: '#ffffff',
          scaledSize: { width: 26, height: 26 },
          labelOrigin: { x: 13, y: 13 }
        }
      }
      if (data.is_paused) {
        return {
          url: mapIcoPaused,
          strokeColor: '#ffffff',
          scaledSize: { width: 26, height: 26 },
          labelOrigin: { x: 13, y: 13 }
        }
      }
      return {
        url: mapIcoFree,
        strokeColor: '#ffffff',
        scaledSize: { width: 26, height: 26 },
        labelOrigin: { x: 13, y: 13 }
      }
    },
    openMessages () {
      this.$store.state.messages.isOpen = true
      this.$store.dispatch('messages/fetchConversations').then(() => {
        setTimeout(() => {
          this.$store.commit('messages/addNewConversation', {
            conversation: {
              last_message_at: null,
              interlocutor_id: this.Sofer.id,
              name: this.Sofer.name,
              phone: this.Sofer.phone,
              email: this.Sofer.email,
              has_unread: false,
              unread_count: 0
            }
          })
        }, 500)
      })
    }
  },
  watch: {
    driversLocationsFiltered: function (results) {
      if (results.length === 1) {
        this.mapCenter.lat = results[0].lat
        this.mapCenter.long = results[0].long
      }
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>

</style>
